import React from 'react';
import { modalEdit } from '../../redux/slices/modal.slice';
import { addChosenSubscription } from '../../redux/slices/subscriptions.slice';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

// This component is used in two places and they do not look the same:
//   - the plan picker (pages/Subscription), where a studio owner chooses what to buy.
//     That is the card Andrew redesigned on 2026-09-15: a white card with a coloured
//     stripe and a coloured plan name, instead of the old full-height colour block.
//   - the profile page (components/ProfileInformation), which passes info: true to show
//     the plan the studio is already on. That variant is untouched by the redesign and
//     still renders exactly as it did before.
function OneSubscription({ data, mostPopular = false }) {
    const { subscriptionName, studiosNumber, stickersNumber, price, payment, color, info } = data;
    const dispatch = useDispatch();
    const { isAdmin, id } = useSelector(state => state.personality.user);

    const openModal = () => {
        if (!isAdmin) return
        dispatch(addChosenSubscription({ ...data, paid: info ? true : false }));
        dispatch(modalEdit('Subscriptions'));
    }

    const rooms = (
        <li>{studiosNumber === null ? <span>Unlimited</span> : <>Up to <span>{studiosNumber}</span> </>} Room{studiosNumber > 1 || studiosNumber === null ? 's' : ''} Per Schedule </li>
    );
    const classes = (
        <li>{stickersNumber === null ? <span>Unlimited</span> : <>Up to <span>{stickersNumber}</span> </>}  Classe{stickersNumber > 1 || stickersNumber === null ? 's' : ''} Per Schedule </li>
    );

    // The profile page's "what you are on right now" card. Unchanged.
    if (info) {
        const infoClassName = [
            styles.wrapperSubscription,
            styles[`wrapperSubscription${color}`],
            styles.wrapperSubscription__info,
        ].join(' ');

        return (
            <div className={styles.center} onClick={!isAdmin ? null : openModal}>
                <div className={infoClassName}>
                    <div className={styles.topLine}></div>
                    <div className={styles.header}>
                        <div className={styles.name}>{subscriptionName}</div>
                        {price ? <div className={styles.coast}>$ {price}<span> /per year</span></div> : null}
                    </div>
                    <ul className={styles.infoList}>
                        {rooms}
                        {classes}
                    </ul>
                    <div className={styles.payment} style={{ visibility: isAdmin ? 'display' : 'display' }}>
                        {payment ? <div >Subscription expires {payment}</div> : null}
                        {!payment && !isAdmin ? (<>
                            <button onClick={() => dispatch({
                                type: 'BUY_SUBSCRIPTION', payload: {
                                    "subscriptionId": data.id,
                                    "userId": id
                                }
                            })}>Purchase</button>
                        </>) : null}
                    </div>
                </div>
            </div>
        )
    }

    // The plan picker card.
    const cardClassName = [
        styles.planCard,
        styles[`planCard${color}`],
        mostPopular ? styles.planCardPopular : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={styles.center} onClick={!isAdmin ? null : openModal}>
            <div className={cardClassName}>
                <div className={styles.planStripe}></div>
                {mostPopular ? <span className={styles.planTag}>Most popular</span> : null}
                <div className={styles.planInner}>
                    <p className={styles.planName}>{subscriptionName}</p>
                    {price ? (
                        <>
                            <p className={styles.planPrice}>${price}</p>
                            <p className={styles.planPer}>per year</p>
                        </>
                    ) : null}
                    <div className={styles.planFits}>
                        <ul>
                            {rooms}
                            {classes}
                        </ul>
                    </div>
                    <div className={styles.planGrow}></div>
                    <div className={styles.planPayment}>
                        {payment ? <div className={styles.planExpires}>Subscription expires {payment}</div> : null}
                        {!payment && !isAdmin ? (
                            <button
                                type="button"
                                className={styles.planButton}
                                onClick={() => dispatch({
                                    type: 'BUY_SUBSCRIPTION', payload: {
                                        "subscriptionId": data.id,
                                        "userId": id
                                    }
                                })}
                            >{subscriptionName ? `Choose ${subscriptionName}` : 'Purchase'}</button>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}


export default OneSubscription
